import { useState } from 'react';
import { TableInput } from '../../../../components/common';
import { ModuleDataHandler } from '../helpers/handleReportCalc';
import formatDate from '../../../../components/common/formatDate';

interface IProps {
  moduleData: any;
  isView: boolean;
  item: any;
  numberOfDay: any;
  index: number;
}

const TBodyRow = ({ moduleData, isView, item, index, numberOfDay }: IProps) => {
  const [render, setRender] = useState<boolean>(false);
  const dataHandler = new ModuleDataHandler(moduleData, numberOfDay);
  return (
    <>
      <tr>
        <td>{index + 1}</td>
        <td>
          {typeof item?.emp_id !== 'string' && item?.emp_id?.employee_name}
        </td>

        <td>
          {typeof item?.emp_id !== 'string' &&
            formatDate(item?.emp_id?.data_of_joining)}
        </td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.el || null}
            onChange={(e) => {
              item.el = Number(e.target.value);
              dataHandler.calculateForPrevBal(index);
              dataHandler.calculateBalance(index);
              setRender((prev) => !prev);
            }}
          />
        </td>
        <td>
          <TableInput isView={true} type="number" value={item.blank || null} />
        </td>
        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.cl || null}
            onChange={(e) => {
              item.cl = Number(e.target.value);
              dataHandler.calculateBalance(index);
              setRender((prev) => !prev);
            }}
          />
        </td>

        {[
          'jan',
          'feb',
          'mar',
          'apr',
          'may',
          'jun',
          'jul',
          'aug',
          'sep',
          'oct',
          'nov',
          'dec',
        ].map((month: any, mIdx: number) => (
          <td key={`month_${month}`}>
            <TableInput
              isView={isView}
              type="number"
              value={item?.month_arr[mIdx] || null}
              onChange={(e) => {
                item.month_arr[mIdx] = Number(e.target.value);
                dataHandler.caclTotalArray(index, 'month_arr', 'total');
                dataHandler.calculateBalance(index);
                setRender((prev) => !prev);
              }}
            />
          </td>
        ))}

        <td>
          <TableInput isView={true} type="number" value={item.total || null} />
        </td>

        <td>
          <TableInput
            isView={true}
            type="number"
            value={item.balance || null}
          />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="text"
            value={item.remarks || null}
            onChange={(e) => {
              item.remarks = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </td>
      </tr>
    </>
  );
};

export default TBodyRow;
